export default {
  schema__ARRIVAL_AIRPORT: "arrival airport",
  schema__ARRIVAL_AIRPORT_REQUIRED: "Enter arrival airport.",
  schema__DEPARTURE_AIRPORT: "departure airport",
  schema__DEPARTURE_AIRPORT_REQUIRED: "Enter departure airport.",
  schema__DEPART_DATE: "Depart date",
  schema__DESTINATION1_AIRPORT: "destination 1 airport",
  schema__DESTINATION2_AIRPORT: "destination 2 airport",
  schema__ERROR_MAX_DATE: (date) => `Please enter a date earlier than ${date}.`,
  schema__ERROR_MIN_DATE: (date) => `Please enter a date after ${date}.`,
  schema__ERROR_MIN_PASSENGER_COUNT: "Please enter at least 1 passenger.",
  schema__PASSENGER_COUNT: "passengers",
  schema__PROMOCODE: "promo code",
  schema__RETURN_DATE: "Return date",
  schema__VALID_ARRIVAL_AIRPORT: "Enter a valid arrival airport.",
  schema__VALID_ARRIVAL_DATE: "Enter valid return date.",
  schema__VALID_DEPARTURE_AIRPORT: "Enter a valid departure airport.",
  schema__VALID_DEPART_DATE: "Enter valid depart date.",
  schema__VALID_DESTINATION1_AIRPORT: "Enter a valid destination 1 airport.",
  schema__VALID_DESTINATION2_AIRPORT: "Enter a valid destination 2 airport.",
};
